import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var ExitNavigationIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.427a1.5 1.5 0 012.17-1.342l6.724 3.362A2 2 0 0121 6.236v11.528a2 2 0 01-1.106 1.789l-6.723 3.361A1.5 1.5 0 0111 21.573V2.427zM16 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6 4a3 3 0 00-3 3v10a3 3 0 003 3h2a1 1 0 100-2H6a1 1 0 01-1-1V7a1 1 0 011-1h2a1 1 0 000-2H6z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(ExitNavigationIcon);